// Curated media library.
// Only items with `visible: true` are shown publicly; `featured: true` items appear on the homepage.
// Each entry follows the editor model recommended in the redesign review:
// title, platform, topic, date, duration, takeaway, URL, feature state and visibility state.

import claudeWorkshopPhoto from '../assets/training-claude-workshop.jpg';
import cohortCertificatesPhoto from '../assets/training-cohort-certificates.jpg';
import liveAgentDemoPhoto from '../assets/training-live-agent-demo.jpg';

export const trainingSessions = [
  {
    id: 'claude-workspace-productivity',
    image: claudeWorkshopPhoto,
    alt: 'Usama Noman with corporate workshop participants after completing the Mastering Claude AI for Workspace Productivity training session at AIGM Hub, Oval Damansara',
    venue: 'AIGM Hub, Oval Damansara',
    topic: 'Corporate AI Workshop',
    badge: 'Full-Day Session',
    title: 'Mastering Claude AI for Workspace Productivity',
    description:
      'Usama Noman delivered an intensive hands-on training session guiding professionals through AI foundations, Claude Projects, workflow automation, and AI agents for business use, captured here with the cohort after completing the workshop.',
    highlights: 'AI Foundations · Claude Projects · Automation · AI Agents',
    visible: true,
  },
  {
    id: 'certified-ai-cohort',
    image: cohortCertificatesPhoto,
    alt: 'Workshop participants proudly holding their Certificates of Completion at AIGM Hub, Oval Damansara',
    venue: 'AIGM Hub, Oval Damansara',
    topic: 'Certified Cohort',
    badge: 'Certification',
    title: 'Certified AI Practitioners & Cohort Completion',
    description:
      'Participants proudly receiving their Certificates of Completion after finishing the intensive hands-on AI training programme, equipped with practical prompting frameworks, custom Claude workflows, and ready-to-deploy business automations.',
    highlights: 'Certified Cohort · Practical Assessment · Real-World AI Workflows',
    visible: true,
  },
  {
    id: 'live-ai-agents-walkthrough',
    image: liveAgentDemoPhoto,
    alt: 'Usama Noman conducting a live AI agent and workflow demonstration on the main screen while participants follow along on laptops',
    venue: 'AIGM Hub, Oval Damansara',
    topic: 'Live Demonstration',
    badge: 'Hands-On Lab',
    title: 'Live AI Agents & Multi-Workflow Execution',
    description:
      'Usama Noman leading a live technical walkthrough, demonstrating how to configure specialized AI agents for content production, creative design, and automated multi-step execution while participants build alongside him on their own laptops.',
    highlights: 'Custom AI Agents · Live Walkthrough · Multi-Step Automation',
    visible: true,
  },
];

const media = [
  {
    id: 'TtyChIQb8tY',
    title: 'Book 100+ appointments from Facebook Lead Ads with Voice AI agents',
    platform: 'YouTube',
    topic: 'Voice AI agents',
    date: 'February 20, 2025',
    duration: '5:39',
    takeaway: 'How a voice agent can call new leads and book appointments without manual follow-up.',
    featured: true,
    visible: true,
  },
  {
    id: 'IrcW8-YNTPY',
    title: 'Warm up GHL & HubSpot prospects with AI voice agents',
    platform: 'YouTube',
    topic: 'CRM automation',
    date: 'February 20, 2024',
    duration: '3:13',
    takeaway: 'Use AI voice calls to re-engage prospects that are sitting idle in your CRM.',
    featured: true,
    visible: true,
  },
  {
    id: 'ZwE_XTkz57o',
    title: 'Confirm Calendly meetings automatically with Voice AI agents',
    platform: 'YouTube',
    topic: 'Workflow automation',
    date: 'February 20, 2025',
    duration: '3:23',
    takeaway: 'Reduce no-shows by letting an agent confirm booked meetings for you.',
    featured: true,
    visible: true,
  },
  {
    id: 'GHDTSveQ__U',
    title: 'Welcome to Vocallify, a voice AI platform',
    platform: 'YouTube',
    topic: 'Product walkthrough',
    date: 'January 14, 2025',
    duration: '0:42',
    takeaway: 'A short introduction to the voice AI product and what it is built for.',
    featured: false,
    visible: true,
  },
  {
    id: 'gPzj8rQDPcw',
    title: 'Integrate a Shopify store inside your chatbot',
    platform: 'YouTube',
    topic: 'Chatbots',
    date: 'September 19, 2023',
    duration: '1:05',
    takeaway: 'Connect product data to a chatbot so customers can browse and buy in conversation.',
    featured: false,
    visible: true,
  },
  {
    id: 'MkPOxmqggs0',
    title: 'Lesson 23: Add important CTAs to your chatbot menu',
    platform: 'YouTube',
    topic: 'Tutorial',
    date: 'December 12, 2024',
    duration: '0:43',
    takeaway: 'Guide visitors to the right next step with a clear chatbot menu.',
    featured: false,
    visible: true,
  },
];

export const youtubeChannel = 'https://www.youtube.com/@botsify';

export default media;
